import { render, staticRenderFns } from "./boothList.vue?vue&type=template&id=c2b949a4&scoped=true&"
import script from "./boothList.vue?vue&type=script&lang=js&"
export * from "./boothList.vue?vue&type=script&lang=js&"
import style0 from "./boothList.vue?vue&type=style&index=0&id=c2b949a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b949a4",
  null
  
)

export default component.exports